import React from 'react';
import { CTAButton } from './CTAButton';
export function MidPageCTA() {
  return <section className="py-8 px-4 bg-white" data-id="element-83" data-mp="1vt8s8t2upbvs">
      <div className="max-w-3xl mx-auto text-center" data-id="element-84" data-mp="1vs60kixpf5et">
        <h2 className="text-xl md:text-2xl font-black text-gray-900 mb-4" data-id="element-85" data-mp="20kh3zvrnl9c4">
          Accedé ahora al pack completo listo para usar durante todo el año
        </h2>
        <CTAButton href="#compra" className="w-full md:w-auto" data-id="element-86" data-mp="25lejg0la3p9x">
          Obtener acceso inmediato al material
        </CTAButton>
      </div>
    </section>;
}